export function Separator() {
  return (
    <div className="h-[2px] rounded flex bg-gradient-to-r from-green-500 to-sky-500"></div>
  );
}
